import { render } from "./EventCard.vue?vue&type=template&id=d9625300&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=d9625300&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d9625300"

export default script